import { computed, defineComponent } from "vue";

export default defineComponent({
  props: {
    backgroundColor: { type: String, required: true },
    extraMargin: { type: Boolean, required: false },
  },
  setup(props) {
    const sectionClasses = computed(() => {
      let classes = "";

      if (props.backgroundColor) {
        classes += `backgroundwrapper--${props.backgroundColor}`;

        if (props.backgroundColor === "yellow") {
          classes += ` remove-mix-blend-mode`;
        }
      }

      if (props.extraMargin) {
        classes += " backgroundwrapper--extramargin"; // used to make room for display typo
      }

      return classes;
    });

    const texture = computed(() => {
      switch (props.backgroundColor) {
        case "black":
          return "raw-01";
        case "grey":
          return "fine-03";
        default:
          return false;
      }
    });

    return { sectionClasses, texture };
  },
});
